"use client";

import React from "react";
import { Analytics } from "@vercel/analytics/react";
import { usePathname } from "next/navigation";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { ClientAuthProvider } from "@/app/providers/client-auth";
import MaintenanceToast from "@/components/maintanence-toast";

export function ClientRoot({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isArrayWorkspace = pathname?.startsWith("/array");

  return (
    <ClientAuthProvider>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        {children}
        <Analytics />
        <Toaster
          richColors
          position="top-center"
          offset={{ top: isArrayWorkspace ? 116 : 32 }}
          mobileOffset={{ top: isArrayWorkspace ? 116 : 16, left: 16, right: 16 }}
        />
        <MaintenanceToast />
      </ThemeProvider>
    </ClientAuthProvider>
  );
}
